import React, { useEffect } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';
import { FolderDropdown } from '@widgets/Files/UI/FileFolder/FolderDropdown';
import { FolderIcon } from '@widgets/Files/UI/FileFolder/ui/FolderIcon';
import { FolderName } from '@widgets/Files/UI/FileFolder/ui/FolderName';
import { useFileFolder } from '@widgets/Files/UI/FileFolder/useFileFolder';

import cls from './FileFolder.module.css';

interface FileFolderProps {
    folderInfo: IFIleEntity;
    classes?: string;
}
export const FileFolder = ({ folderInfo, classes }: FileFolderProps) => {
    const {
        onFolderClick,
        isFileOver,
        handleDragLeave,
        handleDragEnter,
        handleDragStart,
        onDrop,
        handleDragOver,
    } = useFileFolder(folderInfo);
    const { t } = useTranslation();

    return (
        <div
            className={classNames(cls.FileFolder, isFileOver && cls.onDragOver, [classes])}
            onClick={() => onFolderClick(folderInfo.id)}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={onDrop}
            draggable
        >
            <FolderDropdown folderInfo={folderInfo} />
            <FolderIcon previewSvgUrl={folderInfo.previewSvgUrl} />
            <FolderName folderName={folderInfo.name} />
            {isFileOver && (
                <span className={cls.dragOverTooltip}>
                    {t('Tasks.ModalFileUploader.DnD.isFileOver.text')}
                </span>
            )}
        </div>
    );
};
